module.exports = __webpack_public_path__ + "static/media/Bosinga.b2da109d.png";